import React from 'react';

import { Input } from '@swyftx/aviary/atoms/Input';
import { FlexLayout } from '@swyftx/aviary/atoms/Layout/Flex';
import { Body } from '@swyftx/aviary/atoms/Typography';
import { EnhancedTabs } from '@swyftx/aviary/molecules/EnhancedTabs';
import { MarginOrderDirection, MarginOrderType } from '@swyftx/margin/build/types';
import { MarginInstrument } from '@swyftx/margin/build/types';

import { useMarginPriceInput } from './useMarginPriceInput';

type Props = {
  tradeType: MarginOrderType;
  tradeSide: MarginOrderDirection;
  price: string;
  market: MarginInstrument;
  disabled?: boolean;
  readOnly?: boolean;
  isOpenPosition?: boolean;
  onChange: (price: string) => void;
};

const MarginPriceInput: React.FC<Props> = ({
  tradeSide,
  tradeType,
  price,
  market,
  disabled,
  readOnly,
  isOpenPosition,
  onChange,
}) => {
  const { inputLabel, error, tabs, onChangeTab, formattedAmount, onChangeValue, placeholder } = useMarginPriceInput({
    tradeSide,
    tradeType,
    price,
    isOpenPosition,
    market,
    onChange,
  });

  return (
    <FlexLayout direction='column' className='w-full' spacing={8}>
      <FlexLayout direction='column' spacing={4}>
        <Input
          variant='monospace'
          disabled={disabled}
          leading={
            <Body className='whitespace-nowrap' color='primary'>
              {inputLabel}
            </Body>
          }
          value={formattedAmount}
          error={!!error}
          onChange={onChangeValue}
          className='text-right text-16 font-medium'
          readOnly={readOnly}
          placeholder={placeholder}
        />
        {error && (
          <Body size='xsmall' color='error'>
            {error}
          </Body>
        )}
      </FlexLayout>
      {tradeType !== MarginOrderType.Market && !readOnly && (
        <EnhancedTabs fullWidth value='' onChange={onChangeTab} tabs={tabs} size='sm' />
      )}
    </FlexLayout>
  );
};

export { MarginPriceInput };
